import { useMemo } from 'react';

import { type TagItem, useAvailableTags } from '@/entities/tags';

import { convertTagsToTree } from './tagTree';

export const useTagsTreeSelect = (tags: TagItem[]) => {
  const { data: availableTags = [], isLoading } = useAvailableTags();

  const tagsTreeData = useMemo(() => {
    if (!availableTags || availableTags.length === 0) return [];
    return convertTagsToTree(availableTags);
  }, [availableTags]);

  const tagsValues = useMemo(() => {
    if (!tags || tags.length === 0) return [];
    return tags.map((tag) => tag.tagFQN);
  }, [tags]);

  return {
    tagsTreeData,
    tagsValues,
    isLoading,
  };
};
